module.exports = __webpack_public_path__ + "img/myAgency.15110003.svg";